var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    {
      staticClass: "w-full overflow-y-auto",
      attrs: { id: "scroller", "scroll-region": "" },
    },
    [
      _c("div", {
        directives: [
          {
            name: "intersect",
            rawName: "v-intersect",
            value: {
              root: "#scroller",
              handler: _vm.bottomVisible,
              options: { rootMargin: "100px", threshold: 0 },
            },
            expression:
              "{\n            root: '#scroller',\n            handler: bottomVisible,\n            options: { rootMargin: '100px', threshold: 0 },\n        }",
          },
        ],
        attrs: { id: "bottom-anchor" },
      }),
      _vm._v(" "),
      _vm.nextLoading && _vm.conversation.message_id
        ? _c(
            "div",
            {
              staticClass: "w-full flex justify-center align-center absolute",
              staticStyle: { bottom: "-1rem" },
            },
            [
              _c("v-progress-circular", {
                staticClass: "mr-4",
                attrs: { indeterminate: "", color: "primary" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.messageData, function (message, idx) {
        return _c(
          "div",
          {
            key: message.id,
            staticClass:
              "flex flex-col scroller-item custom-animate animate__animated animate__fadeIn",
          },
          [
            _c(
              "v-list-item",
              {
                staticClass: "chat-items soli-round mx-3 px-1 inactive",
                class: `thread-${message.thread_id}`,
                attrs: { id: `message-${message.id}` },
              },
              [
                _c(
                  "div",
                  { staticClass: "soli-round soli-grey pa-2 flex justify-end" },
                  [
                    _c(
                      "v-avatar",
                      {
                        staticClass: "mr-4",
                        attrs: {
                          size: _vm.$vuetify.breakpoint.smAndUp ? 48 : 36,
                        },
                      },
                      [
                        _c("v-img", {
                          attrs: {
                            src:
                              _vm.participants.find(
                                (e) => e.id == message.messagable_id
                              )?.profile_photo_url ??
                              _vm.conversationUser.messagable.profile_photo_url,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col" },
                      [
                        _c(
                          "div",
                          { staticClass: "flex font-weight-bold items-center" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.participants.find(
                                    (e) => e.id == message.messagable_id
                                  )?.messagable_name ??
                                    _vm.conversationUser.messagable
                                      .messagable_name
                                )
                            ),
                            _c(
                              "small",
                              { staticClass: "caption ml-2 my-auto" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .moment(new Date(message.created_at))
                                      .format("h:mm A")
                                  ) + "\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            ["sms", "mms", "email", "voice"].includes(
                              message.channel
                            )
                              ? _c("div", { staticClass: "contents" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mx-2 flex gap-1 items-center",
                                    },
                                    [
                                      message.channel
                                        ? _c(
                                            "v-chip",
                                            {
                                              staticClass: "font-bold px-2",
                                              attrs: {
                                                "x-small": "",
                                                color: _vm.channelColors(
                                                  message.channel
                                                ),
                                              },
                                            },
                                            [_vm._v(_vm._s(message.channel))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      message.messagable_id ==
                                        _vm.conversationUser.messagable_id &&
                                      message.messagable_type ==
                                        _vm.conversationUser.messagable_type &&
                                      ["sms", "mms", "email", "voice"].includes(
                                        message.channel
                                      )
                                        ? _c(
                                            "div",
                                            { staticClass: "contents" },
                                            [
                                              message.status == "delivered"
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "ml-1",
                                                      attrs: {
                                                        "x-small": "",
                                                        color: "success",
                                                      },
                                                    },
                                                    [_vm._v("done")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              message.status == "failed" ||
                                              message.status == "undelivered" ||
                                              !message.status
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "ml-1",
                                                      attrs: {
                                                        "x-small": "",
                                                        color: "error",
                                                      },
                                                    },
                                                    [_vm._v("sms_failed")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              message.status == "opt_out"
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "ml-1",
                                                      attrs: {
                                                        "x-small": "",
                                                        color: "error",
                                                      },
                                                    },
                                                    [_vm._v("front_hand")]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            message.channel !== "chat"
                              ? _c(
                                  "v-menu",
                                  {
                                    attrs: { left: "", "offset-y": "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      icon: "",
                                                      color: "dark",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.$log(
                                                          message.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { small: "" } },
                                                    [_vm._v("more_vert")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c(
                                      "v-list",
                                      [
                                        _c(
                                          "v-list-item",
                                          {
                                            attrs: {
                                              disabled:
                                                !message.thread_messages_count,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.$emit(
                                                  "changeThread",
                                                  {
                                                    id: message.thread_id,
                                                  }
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Reply")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-item",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.markUnread(message)
                                              },
                                            },
                                          },
                                          [_vm._v("Mark Unread")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        message.channel == "email"
                          ? _c("div", { staticClass: "caption" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(`Subject: ${message.subject}`) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("TipTapReader", {
                          staticClass: "message-content",
                          attrs: { value: message.content },
                        }),
                        _vm._v(" "),
                        message.thread_messages_count > 1
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "caption accent--text cursor-pointer w-max",
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("changeThread", {
                                      id: message.thread_id,
                                    })
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      `${message.thread_messages_count} messages`
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("MessageDividers", {
              attrs: {
                isUnread: _vm.unreadId
                  ? message.id == _vm.unreadId
                  : message.firstUnread,
                isDateIndicator:
                  idx ==
                  _vm.messageData.map((e) => e.date).lastIndexOf(message.date),
                date: message.date,
              },
            }),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "intersect",
            rawName: "v-intersect",
            value: {
              root: "#scroller",
              handler: _vm.topVisible,
              options: { rootMargin: "-100px", threshold: 0 },
            },
            expression:
              "{\n            root: '#scroller',\n            handler: topVisible,\n            options: { rootMargin: '-100px', threshold: 0 },\n        }",
          },
        ],
        attrs: { id: "top-anchor" },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-full h-full flex justify-center align-center my-4",
          staticStyle: { "min-height": "32px" },
        },
        [
          _vm.previousLoading
            ? _c("v-progress-circular", {
                staticClass: "mr-4",
                attrs: { indeterminate: "", color: "primary" },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }